export const getToWithGclid = (to, gclid) => {
  const baseUrl = new URL(to, 'https://dummy.com');
  const params = new URLSearchParams(baseUrl.search);
  params.append('gclid', gclid);

  return baseUrl.pathname + '?' + decodeURIComponent(params.toString());
};
